import { Routes, Route } from 'react-router-dom';
import PageHome from '@pages/page-home';
import PageTalk from '@pages/page-talk';

export default function AppRouters() {
	return (
		<Routes>
			<Route path="/" element={<PageHome />} />
			<Route path="/talk" element={<PageTalk />} />
		</Routes>
	)
}
